// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iconfont[data-v-a5670b5a]{font-size:4.267vw;color:#e4e4ef}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
